module.exports = { "default": require("core-js/library/fn/object/assign"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-runtime/core-js/object/assign.js
// module id = 240
// module chunks = 0 1


// WEBPACK FOOTER //
// webpack:///node_modules/babel-runtime/core-js/object/assign.js